var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 65,
    viewBox: "0 0 58 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 32.5,
    rx: 29,
    ry: 32.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4932 42.4514L28.5 55.4446L15.5068 42.4514C12.9371 39.8816 11.187 36.6075 10.4781 33.0431C9.76908 29.4787 10.133 25.7842 11.5237 22.4266C12.9145 19.069 15.2697 16.1992 18.2914 14.1802C21.3132 12.1611 24.8658 11.0834 28.5 11.0834C32.1342 11.0834 35.6868 12.1611 38.7086 14.1802C41.7303 16.1992 44.0855 19.069 45.4763 22.4266C46.867 25.7842 47.2309 29.4787 46.522 33.0431C45.813 36.6075 44.0629 39.8816 41.4932 42.4514V42.4514ZM28.5 37.6249C30.6659 37.6249 32.7432 36.7645 34.2747 35.233C35.8063 33.7014 36.6667 31.6242 36.6667 29.4583C36.6667 27.2923 35.8063 25.2151 34.2747 23.6836C32.7432 22.152 30.6659 21.2916 28.5 21.2916C26.3341 21.2916 24.2568 22.152 22.7253 23.6836C21.1938 25.2151 20.3333 27.2923 20.3333 29.4583C20.3333 31.6242 21.1938 33.7014 22.7253 35.233C24.2568 36.7645 26.3341 37.6249 28.5 37.6249V37.6249ZM28.5 33.5416C27.417 33.5416 26.3784 33.1114 25.6127 32.3456C24.8469 31.5799 24.4167 30.5412 24.4167 29.4583C24.4167 28.3753 24.8469 27.3367 25.6127 26.5709C26.3784 25.8052 27.417 25.3749 28.5 25.3749C29.583 25.3749 30.6216 25.8052 31.3874 26.5709C32.1531 27.3367 32.5833 28.3753 32.5833 29.4583C32.5833 30.5412 32.1531 31.5799 31.3874 32.3456C30.6216 33.1114 29.583 33.5416 28.5 33.5416Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker1);
export default __webpack_public_path__ + "static/media/marker1.fc6969a285ca2b4239483d6464733f28.svg";
export { ForwardRef as ReactComponent };